<div class="modal-header">
  <h6 class="modal-title" id="modal-basic-title">Gestión de vehículos</h6>
  <button type="button" class="close" (click)="onDismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<main class="container-fluid">
  <article class="row row bg-white shadow mb-3 mt-3 ml-0 mr-0 ">
    <section class="col-3 border-right p-4 mt-5 mb-5">
      <header class="text-center mb-3">
        <!-- <figure class="col-3 m-auto">
            <img src="../../../../../../../../assets/icons/tecnica.png" class="d-inline-block p-2 rounded-circle" alt=""
              height="60">
          </figure>
          <div class="col row ml-1">
            <label class="text-muted small mb-0 ml-1">Gestión de <br><strong class="h5 text-body">Vehículos</strong></label>
          </div> -->
        <label class="h5">Gestión de vehículos</label>
      </header>
      <form [formGroup]="formVehiculo" (ngSubmit)="onAgregarVehiculo()">
        <div class="form-group mb-3">
          <label class="small text-secondary">Marca</label>
          <select id="marca" formControlName="marca_id" class="form-control" (ngModelChange)="onChangeMarca($event)">
            <option value="null" selected="true">Seleccione</option>
            <ng-container *ngFor="let item of marcasVehiculo">
              <option [ngValue]="item.marca_id">{{item.descripcion}}</option>
            </ng-container>
          </select>
        </div>
        <div class="form-group mb-3">
          <label class="small text-secondary">Línea</label>
          <select id="linea" formControlName="linea_id" class="form-control">
            <option value="null" selected="true">Seleccione</option>
            <ng-container *ngFor="let item of lineasVehiculo">
              <option [ngValue]="item.linea_id">{{item.descripcion}}</option>
            </ng-container>
          </select>
        </div>
        <div class="form-group mb-3">
          <label class="small text-secondary">Placa</label>
          <input class="form-control" formControlName="placa" />
          <div id="mensaje" *ngIf="!formVehiculo.controls.placa.valid  && (formVehiculo.get('placa').dirty)">
            <p class="small text-danger mt-1 position-absolute font-weight-bold" text-right>Número de caracteres no
              permitido</p>
          </div>
        </div>
        <div class="form-group mb-3">
          <label class="small text-secondary">Color</label>
          <input class="form-control" formControlName="color" />
        </div>
        <div class="form-group mt-auto text-center">
          <ng-container *ngIf="selectVehiculo == null; else editarCapacidadTecnica">
            <button type="button" class="btn btn-primary m-auto solicitud-btn-principal"
              [disabled]="!formVehiculo.valid" (click)="onAgregarVehiculo()">Agregar</button>
          </ng-container>
          <ng-template #editarCapacidadTecnica>
            <button type="button" class="btn btn-primary m-auto solicitud-btn-principal"
              [disabled]="!formVehiculo.valid" (click)="onModificarVehiculo()">Editar</button>
          </ng-template>
        </div>
      </form>
    </section>
    <section class="col-9 p-4 mt-5 mb-5" *ngIf="dataTabla?.paging.totalItems >= 1; else no_data">
      <img src="../../../../../assets/icons/solicitud.png" class="d-inline-block img-responsive mr-3" alt="">
      <label *ngIf="dataTabla?.paging.totalItems > 0" class="text-muted"><strong>Vehículos registrados</strong></label>
      <!-- <textarea *ngIf="dataTabla.paging.totalItems >= 1" class="form-control-plaintext h-25"
          disabled="true">Descripción vehículos</textarea> -->
      <div class="table-responsive">
        <app-tablas [page]="paginaActual" [headers]="headersVehiculo" [sizeData]="dataTabla.paging.totalItems"
          class="table-responsive overflow" (paginado)="onPaginado($event)">
          <tr *ngFor="let item of dataTabla.items" class="small">
            <td>{{item.desc_marca}}</td>
            <td>{{item.desc_linea}}</td>
            <td>{{item.placa}}</td>
            <td>{{item.color}}</td>
            <td>
              <img src="/assets/icons/edit.png" class="pointer" alt="" (click)="onCargarEditarVehiculo(item)"
                height="25">
              <img src="/assets/icons/delete.png" class="pointer" alt="" (click)="onEliminarVehiculo(item)" height="25">
            </td>
          </tr>
        </app-tablas>
      </div>
      <div class="row text-center">
        <button type="button" class="btn btn-primary" (click)="onDismiss()">Salir</button>
      </div>
    </section>
    <ng-template #no_data>
      <section class="col-9 p-4 mt-5 mb-5">
        <header class="col-12">
          <figure class="figure w-100 text-center">
            <img class="img-fluid mb-4" src="../../../../../../../assets/images/sin_establecimiento.png" />
            <figcaption>
              <label class="h3">Aún no tienes vehículos registrados</label>
            </figcaption>
          </figure>
        </header>
        <div class="row text-right">
          <button type="button" class="btn btn-primary" (click)="onDismiss()">Salir</button>
        </div>
      </section>
    </ng-template>
  </article>
</main>